module.exports = __webpack_public_path__ + "img/arrow-left-yellow.4084c015.svg";